export const CITY_AUTOCOMPLETE_API = `/api/geography/cities`;
